import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import DynamicForm from "components/DynamicForm";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  createSmsAssignmentsToMachineThunk,
  getSmsAssignmentsThunk,
} from "store/reducers/third_party/smsProviderAllocationSlice";
import {
  getSmsServiceProvidersThunk,
  smsServiceProviderSelector,
} from "store/reducers/third_party/smsProviderSlice";

const AlertAllocationCreation = () => {
  const dispatch = useDispatch();

  const [sms, setSms] = React.useState("");
  const [serviceType,setServiceType] = React.useState("otp");
  const handleItemChange = (event) => {
    setSms(event.target.value);
  };
  useEffect(() => {
    dispatch(getSmsServiceProvidersThunk());
  }, []);
  const smsServiceProviders = useSelector(smsServiceProviderSelector.selectAll);

  useEffect(() => {
    dispatch(getSmsAssignmentsThunk());
  }, []);

  const { status } = useSelector((state) => state.smsAssignments);

  const onCredentialFormatSubmit = (data) => {
    const request = {
      service: sms.id,
      authentication: data,
      service_type:serviceType
    };
    dispatch(createSmsAssignmentsToMachineThunk(request));
  };

  return (
    <Grid container>
      <Grid item xs={12} xl={4} >
        <Stack direction="column">
          <Typography sx={{ mb: 1 }} variant="h5">
            Add a new provider
          </Typography>

          <Box display="flex">
            <FormControl sx={{ width: "100%" }} size="small">
              <InputLabel>Choose sms providers</InputLabel>
              <Select
                value={sms}
                label="Choose sms providers"
                onChange={handleItemChange}
              >
                <MenuItem value={null}>
                  <em>None</em>
                </MenuItem>
                {smsServiceProviders.map((validation) => (
                  <MenuItem key={validation.id} value={validation}>
                    {validation.name}
                  </MenuItem>
                ))}
              </Select>
              <TextField
                label="Validation required"
                variant="outlined"
                name="validation_required"
                select
                fullWidth
                sx={{ mt: 3 }}
                value={serviceType}
                onChange={(e)=>setServiceType(e.target.value)}
                autoComplete="new-password"
              >
                <MenuItem value="otp">OTP</MenuItem>
                <MenuItem value="error">Error</MenuItem>
                <MenuItem value="stock">Stock</MenuItem>
              </TextField>
            </FormControl>
          </Box>

          {sms && (
            <>
              <Typography variant="h6" color="gray" marginTop={1}>
                Do you want to add {sms.name} to this machine ?
              </Typography>
              {sms.credential_format.length > 0 ? (
                <>
                  <Typography variant="caption" color="gray" marginTop={1}>
                    {sms.name} required the following details to proceed
                  </Typography>
                  <DynamicForm
                    items={sms.credential_format}
                    buttonText="Submit"
                    buttonType="outlined"
                    grid={{ xs: 12, md: 12, lg: 12 }}
                    loading={status?.loading === "create"}
                    onSubmit={onCredentialFormatSubmit}
                    sx={{ mt: 2 }}
                  />
                  {status?.error === "create" && (
                    <Alert sx={{ mt: 3 }} severity="error">
                      Error occurred
                    </Alert>
                  )}
                  {status?.success === "create" && (
                    <Alert sx={{ mt: 3 }} severity="success">
                      Success
                    </Alert>
                  )}
                </>
              ) : (
                <>
                {status?.error === "create" && (
                    <Alert sx={{ mt: 3 }} severity="error">
                      Error occurred
                    </Alert>
                  )}
                  {status?.success === "create" && (
                    <Alert sx={{ mt: 3 }} severity="success">
                      Success
                    </Alert>
                  )}
                  <LoadingButton
                    loading={status?.loading === "create"}
                    variant="outlined"
                    type="submit"
                    sx={{ mt: 2 }}
                    onClick={() => onCredentialFormatSubmit(null)}
                  >
                    Add this validation
                  </LoadingButton>
                </>
              )}
            </>
          )}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default AlertAllocationCreation;
